<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Daily Uploads</h2>
                      <div class="ims-tab ml-0">
                        <router-link to="/ims/ims-dailyuploads" class="inv-btn">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='imsDailyUploadsList' }" >
                              Daily Uploads
                          </button>
                        </router-link>
                        <router-link to="/ims/ims-dailyuploads/pricechange">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='imsDailyPriceChangeList' }" >
                              Price Change
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <router-view></router-view>

    </div> 
</template>
<script>
export default {
  name: "imsDailyUpload",
  components : {

  },
  data() {
    return {
        loading : false,
    };
  },
  methods: {

  },
  mounted() {
  }
};
</script>